<template>
    <div class="ticketDetails" v-if="pageShow">
        <div class="scrollBox">
            <div class="activityMsg" @click="checkAtyMsg">
                <div class="imgBox">
                    <img :src="eventinfo.coveratturlid" alt="">
                </div>
                <div class="textBox">
                    <p class="title">{{eventinfo.title}}</p>
                    <div class="time">{{eventinfo.begintime}}-{{eventinfo.endtime}}</div>
                    <p class="adress">{{eventinfo.address}}</p>
                </div>
            </div>
            <div class="refuseReason" v-if="eventinfo.ticketstatus === 3">{{memo}}</div>
            <div class="listBox" v-show="ticketlist.length">
                <div v-for="(item, index) in ticketlist" :key="index" class="itemBox">
                    <div class="choiceBox" v-if="show">
                        <van-checkbox v-model="item.check" :disabled="item.disabled" shape="square" checked-color="#0ABF53"></van-checkbox>
                    </div>
                    <div class="item" @click="oneTicketMsg(item)">
                        <p class="title">{{item.ticketname}}</p>
                        <div class="participant">
                            <p class="left">参加人:</p>
                            <div class="right">
                                <div class="participantItem" v-for="(obj, i) in item.joinlist" :key="i">
                                    <p class="name">{{obj.joinername}}</p>
                                    <p class="phoneNum">{{obj.joinermobile}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="ticketNum" v-if="item.ticketnolist.length">
                            <p class="left">票号：</p>
                            <div class="right">
                                <div class="ticketNumItem" v-for="(obj, i) in item.ticketnolist" :key="i">
                                    <p>{{obj.ticketno}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="statusIconBox">
                            <img :src="require('@/common/images/activeTools/ticket_status01.png')" v-if="item.ticketstatus === 30" alt="">
                            <img :src="require('@/common/images/activeTools/ticket_status02.png')" v-if="item.ticketstatus === 1" alt="">
                            <img :src="require('@/common/images/activeTools/ticket_status03.png')" v-if="item.ticketstatus === 32" alt="">
                            <img :src="require('@/common/images/activeTools/ticket_status04.png')" v-if="item.ticketstatus === 3" alt="">
                            <img :src="require('@/common/images/activeTools/ticket_status05.png')" v-if="item.ticketstatus === 31" alt="">
                            <img :src="require('@/common/images/activeTools/ticket_status06.png')" v-if="item.ticketstatus === 33" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="shareBox" v-if="(eventinfo.ticketstatus !== 32 && eventinfo.ticketstatus !== 3 && eventinfo.ticketstatus !== 1 && eventinfo.ticketstatus !== 100) && ticketlist.length">
            <van-button type="default" class="shareBtn" @click="shareTicket" v-if="!show">分享票券</van-button>
            <div class="shareActionBox" v-else>
                <van-button type="default" class="cancel" @click="cancel">取消</van-button>
                <van-button type="default" class="allChoice" @click="allChoice">{{ allChoiceResult ? '取消全选' : '全选'}}</van-button>
                <van-button type="default" class="shareGiveFriend" :disabled="!shoiceNum" @click="saveEventShareTicket">分享票券给好友({{shoiceNum}})</van-button>
            </div>
        </div>
    </div>
</template>
<script>
import {mapActions} from 'vuex'
import {saveEventShareTicket} from 'api/activeTools'
import {getEventOrderDetail} from 'api/activeMy'
export default {
    name: 'ticketDetails',
    data() {
        return {
            eventinfo: {
                title: '',
                coveratturlid: '',
                begintime: '',
                endtime: '',
                address: '',
                refuseReason: ''
            },
            ticketlist: [],
            show: false,
            shoiceNum: 0,
            eventid: this.$route.query.eventid,
            orderno: this.$route.query.orderno,
            pageShow: false,
            memo: '',
            ticketstatus: '',
            ticketstatusname: '',
            allChoiceResult: false
        }
    },
    mounted() {
        this.getEventOrderDetail()
    },
    methods: {
        checkAtyMsg() {
            this.$router.push({name: 'ActivityDetail', query: {eventid: this.eventid}})
        },
        shareTicket() {
            this.show = true
        },
        cancel() {
            this.show = false
            this.shoiceNum = 0
            this.ticketlist.forEach(obj => {
                obj.check = false
            })
        },
        allChoice() {
            if (!this.allChoiceResult) {
                this.ticketlist.forEach(obj => {
                    if (obj.ticketstatus === 31) {
                        obj.check = true
                        this.allChoiceResult = true
                    }
                })
            } else {
                this.ticketlist.forEach(obj => {
                    if (obj.ticketstatus === 31) {
                        obj.check = false
                        this.allChoiceResult = false
                    }
                })
            }
        },
        // 获取订单详情
        getEventOrderDetail() {
            this.setLoading(true)
            getEventOrderDetail({
                data: {eventid: this.eventid, orderno: this.orderno},
                success: data => {
                    this.setLoading(false)
                    this.eventinfo = data.data.eventinfo
                    document.title = this.eventinfo.title
                    data.data.ticketlist.forEach(obj => {
                        if (obj.ticketstatus !== 31 && obj.ticketstatus !== 30) {
                            obj.disabled = true
                        }
                        obj.check = false
                    })
                    this.memo = data.data.eventinfo.memo
                    // this.ticketstatus = data.data.eventinfo.ticketstatus
                    this.ticketlist = data.data.ticketlist
                    this.pageShow = true
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        // 分享票券给好友 
        saveEventShareTicket() {
            let itemid = ''
            this.ticketlist.forEach(obj => {
                if (obj.check) {
                    itemid += obj.itemid + ','
                }
            })
            if (itemid.slice(-1) === ',') {
                itemid = itemid.substring(0, itemid.length - 1)
            }
            this.setLoading(true)
            saveEventShareTicket({
                data: {eventid: this.eventid, orderno: this.orderno, itemid},
                success: data => {
                    this.setLoading(false)
                    this.$router.push({name: 'tickteShare', query: {shareid: data.data.shareid, eventid: this.eventid}})
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        oneTicketMsg(item) {
            this.$router.push({name: 'oneTicketDetails', query: {eventid: this.eventid, itemid: item.itemid}})
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        'ticketlist': {
            handler(newV) {
                let num = 0
                newV.forEach(obj => {
                    if (obj.check) {
                        num++
                    }
                })
                if (num === this.ticketlist.length) {
                    this.allChoiceResult = true
                }
                this.shoiceNum = num
            },
            deep: true
        }
    }
}
</script>
<style lang="scss">
    .ticketDetails{
        height: 100%;
        display: flex;
        flex-direction: column;
        .scrollBox{
            flex: 1;
            overflow-y: scroll;
            .activityMsg{
                display: flex;
                align-items: center;
                padding: 0.4rem 0.32rem;
                background: #fff;
                margin-bottom: 0.2rem;
                .imgBox{
                    width: 2.6rem;
                    height: 1.6rem;
                    img{
                        width: 2.6rem;
                        height: 1.6rem;
                        border-radius: 0.1rem;
                        box-shadow: 0.01rem 0.05rem 0.05rem #D8D8D8;
                    }
                }
                .textBox{
                    margin-left: 0.2rem;
                    .title{
                        width: 100%;
                        font-size: 0.26rem;
                        line-height: 0.38rem;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                        font-weight: bolder;
                    }
                    .time{
                        font-size: 0.2rem;
                        color: #666666;
                        line-height: 0.28rem;
                        margin: 0.08rem 0;
                    }
                    .adress{
                        width: 100%;
                        font-size: 0.2rem;
                        line-height: 0.28rem;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                }
            }
            .refuseReason{
                line-height: 0.4rem;
                background: #FFF7EC;
                color: #FF4747;
                // text-indent: 0.32rem;
                font-size: 0.28rem;
                padding: 0.2rem 0.32rem;
                box-sizing: border-box;
            }
            .listBox{
                padding: 0 0.32rem 0.32rem;
                background: #fff;
                .itemBox{
                    display: flex;
                    align-items: center;
                    .choiceBox{
                        margin-right: 0.32rem;
                        .van-checkbox{
                            width: 0.32rem;
                            height: 0.32rem;
                            .van-checkbox__icon{
                                width: 0.32rem;
                                height: 0.32rem;
                                .van-icon{
                                    width: 0.32rem;
                                    line-height: 0.32rem;
                                    height: 0.32rem;
                                }
                            }
                        }
                    }
                    .item{
                        box-shadow:0px 0rem 0.06rem 0px rgba(0,0,0,0.1);
                        border-radius:0.1rem;
                        margin-top: 0.32rem;
                        padding: 0.32rem;
                        position: relative;
                        flex: 1;
                        .title{
                            font-size: 0.28rem;
                            font-weight: 550;
                            padding-bottom: 0.22rem;
                        }
                        .participant, .ticketNum{
                            display: flex;
                            margin-bottom: 0.12rem;
                            color: #666666;
                            font-size: 0.28rem;
                            .left{
                                width: 1.2rem;
                                padding-top: 0.05rem;
                            }
                            .right{
                                .participantItem{
                                    display: flex;
                                    .name{
                                        margin-right: 0.2rem;
                                        width: 1rem;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                    }
                                    p{
                                        line-height: 0.4rem;
                                    }
                                }
                                .ticketNumItem{
                                    p{
                                        line-height: 0.4rem;
                                    }
                                }
                            }
                        }
                        .ticketNum{
                            margin-bottom: 0;
                        }
                        .statusIconBox{
                            position: absolute;
                            right: 0;
                            top: 0;
                            img{
                                width: 0.9rem;
                                height: 0.9rem;
                            }
                        }
                    }
                }
                
            }
        }
        .shareBox{
            height: 1.1rem;
            background: #fff;
            padding: 0.17rem 0.32rem;
            box-sizing: border-box;
            margin-top: 0.2rem;
            .shareBtn{
                width: 100%;
                padding: 0;
                height: 0.76rem;
                line-height: 0.76rem;
                background: linear-gradient(360deg,rgba(10,191,83,1) 0%,rgba(71,236,201,1) 100%);
                color: #fff;
                border-radius: 0.4rem;
            }
            .shareActionBox{
                display: flex;
                .cancel, .allChoice{
                    width: 1.46rem;
                    height: 0.76rem;
                    line-height: 0.76rem;
                    padding: 0;
                    border-radius: 0.38rem;
                    margin-right: 0.32rem;
                }
                .shareGiveFriend{
                    flex: 1;
                    background:linear-gradient(360deg,rgba(10,191,83,1) 0%,rgba(71,236,201,1) 100%);
                    border-radius:0.4rem;
                    padding: 0;
                    height: 0.76rem;
                    color: #fff;
                    line-height: 0.76rem;
                }
            }
        }
    }
</style>